import { ForgotPasswordView } from "./forgot-password-view";
import { useForgotPassword } from "./use-forgot-password";

const ForgotPassword = () => {
  const logic = useForgotPassword();
  return <ForgotPasswordView {...logic} />;
};

export default ForgotPassword;
